import { HELP_CENTER_CLICKED } from 'app/features/helpCenter/actionTypes';
import { BOTTOM } from 'app/analytics/constants/positions';
import {
  QUESTION_SELECTED,
  THIRD_PARTY_BUNDLE_NAVIGATED,
} from 'app/features/success/helpCenterBlock/actionTypes';
import { commonActionDetail } from 'app/analytics/selectors';
import { ActionDetail } from 'app/analytics/helpers';

const helpCenter = {
  [HELP_CENTER_CLICKED]: getState => ({
    type: 'track',
    name: 'Help / FAQ',
    properties: ActionDetail({
      position: BOTTOM,
      textOfButtonOrLink: 'Help Center',
      ...commonActionDetail(getState()),
    }),
  }),
  [QUESTION_SELECTED]: (getState, { payload }) =>
    !payload.isOpened && {
      type: 'track',
      name: 'Help / FAQ',
      properties: ActionDetail({
        position: BOTTOM,
        textOfButtonOrLink: payload.anchor,
        ...commonActionDetail(getState()),
      }),
    },
  [THIRD_PARTY_BUNDLE_NAVIGATED]: (getState, { payload }) => ({
    type: 'track',
    name: '3rd Party Bundle Benefit Link Navigated',
    properties: ActionDetail({
      ...commonActionDetail(getState()),
      ...payload,
    }),
  }),
};

export default helpCenter;
